<ng-template #header>
	<h3>
		-
		{{
			(reportParamsObj.showByCreatedAt == "yes"
				? "show_by_created_at"
				: "show_by_expense_date"
			) | langVal
		}}
	</h3>
</ng-template>
<div class="d-flex flex-column gap-3">
	<div class="d-flex gap-3">
		<div>
			<label>{{ "show_expenses" | langVal }}</label>
			<app-gen-button-group
				[actualObj]="reportParamsObj"
				fieldName="showByCreatedAt"
				optionsListName="showByCreatedAt_opts"
				title_ph_lang="show_by_created_at"
				(changeEvent)="
					changeBtn('showByCreatedAt', reportParamsObj.showByCreatedAt)
				"
			></app-gen-button-group>
		</div>
		<div>
			<label>{{ "taxes_report_mode" | langVal }}</label>
			<app-gen-button-group
				[actualObj]="this"
				fieldName="taxesReportMode"
				optionsListName="taxesReportMode_opts"
				title_ph_lang="taxes_report_mode"
				(changeEvent)="changeBtn('taxesReportMode', taxesReportMode)"
			></app-gen-button-group>
		</div>

		@if (is_new_vat_number) {
			<div>
				<app-gen-select
					[actualObj]="reportParamsObj"
					fieldName="vat_number"
					[options]="vat_numbers"
					(changeEvent)="changeBtn('vat_number', reportParamsObj.vat_number)"
				></app-gen-select>
			</div>
		}
	</div>
	<div class="d-flex gap-3">
			<div>
			<label>{{ "period" | langVal }}</label>
			<app-gen-button-group
				isArray
				[actualObj]="reportParamsObj"
				fieldName="report_period_input"
				title_ph_lang="period"
				[options]="periodInputs"
				(changeEvent)="changeBtn('report_period_input', $event)"
			></app-gen-button-group>
	</div>
	@if (reportParamsObj.report_period_input == "date_range") {
		<div class="d-flex gap-2">
			<div class="colstat-price">
				<label>{{ "from_date" | langVal }}</label>
				<app-date-picker
					[actualObj]="reportParamsObj"
					[errors]="errors"
					fieldName="from_date"
					(changeEvent)="onDateChange('from_date')"
					[addonObject]="{ after: { icon: 'calendar' } }"
				>
				</app-date-picker>
			</div>
			<div class="colstat-price">
				<label>{{ "date_to" | langVal }}</label>
				<app-date-picker
					[actualObj]="reportParamsObj"
					[errors]="errors"
					fieldName="to_date"
					(changeEvent)="onDateChange('to_date')"
					[addonObject]="{ after: { icon: 'calendar' } }"
				>
				</app-date-picker>
			</div>
		</div>
	}
	</div>
	<div id="section-to-print">
	<div class="h5" id="period-range">
		<h4>
			<span>{{ "taxes_report" | langVal }} </span>
			- {{
				(reportParamsObj.showByCreatedAt == "yes"
					? "show_by_created_at"
					: "show_by_expense_date"
				) | langVal
			}}
			<span>
				<span>{{ reportParamsObj.from_date | dateFormat }}</span> -
				<span>{{ reportParamsObj.to_date | dateFormat }}</span>
			</span>
		</h4>
	</div>
	@if (taxes) {
		<div class="taxes-report d-flex">
			@if (taxesReportMode | inArray: ["taxes_vat", "taxes"]) {
				<div>
						<div class="gen-title">
							{{ "vat" | langVal }}
						</div>
							<div>
								{{ "pturot" | langVal }}:
								<strong>{{ taxes.total_invoice_vat_exempt }}</strong>
							</div>
							<div>
								{{ "hayavot" | langVal }} :
								<strong>{{ taxes.total_invoice_vat_required }}</strong>
							</div>
							<div>
								{{ "tax_on_transcations" | langVal }} :
								<strong>{{ taxes.total_invoice_vat }}</strong>
							</div>
							<div>
								{{ "tax_tsumot" | langVal }} :
								<strong>{{ taxes.total_expense_vat_permanent }}</strong>
							</div>
							<div>
								{{ "tax_tsumot_other" | langVal }} :<strong>
									{{ taxes.total_expense_vat_not_permanent }}</strong
								>
							</div>
							<div>
								{{ "for_payment" | langVal }} :
								<strong>{{ taxes.vat_for_payment }}</strong>
							</div>
				</div>
			}
			@if (taxesReportMode | inArray: ["taxes_income_tax", "taxes"]) {
				<div>
						<div class="gen-title">
							{{ "taxes_income_tax" | langVal }}
						</div>
							<div>
								{{ "cycle" | langVal }} :<strong>
									{{ taxes.total_invoice_total_without_vat }} *</strong
								>
							</div>
							<div>
								{{ "advanced_percent" | langVal }} :<strong>{{
									taxes.tax_percent_downpayment
								}}</strong>
							</div>
							<div>
								{{ "advanced_by_percent" | langVal }} :
								<strong>{{ taxes.total_invoice_tax_downpayment }}</strong>
							</div>
							<div>
								{{ "tax_for_payment" | langVal }} :
								<strong>{{ taxes.tax_for_payment }}</strong>
							</div>
							<div>{{ "to_be_calculated" | langVal }}</div>
				</div>
			}	
		</div>
	}
</div>
<div class="modal-btns">
	@if (isModalMode) {
		<app-cancel-btn (click)="close()" />
	}
	<button
		tabindex="1"
		class="btn btn-primary"
		(click)="print()"
	>
		{{ "print" | langVal }}
	</button>
	<button
		tabindex="-1"
		class="btn btn-primary"
		(click)="downloadReport()"
	>
		{{ "create_excel" | langVal }}
	</button>
</div>
</div>



